var React = require('react');

function Column (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_5952_51400)","key":0},[React.createElement("path",{"d":"M3 0V12H7.15256e-07L0 0H3Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M12 0V12H9V0H12Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M7.5 12L7.5 0H4.5L4.5 12H7.5Z","fill":"currentColor","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_5952_51400"},React.createElement("rect",{"width":"12","height":"12","fill":"white"})))]);
}

Column.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Column;

Column.default = Column;
